import { render, staticRenderFns } from "./fluxo-caixa.vue?vue&type=template&id=4bf3b728&"
import script from "./fluxo-caixa.vue?vue&type=script&lang=js&"
export * from "./fluxo-caixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports